
import React from 'react';

import { get } from 'lodash';
import { Select } from 'antd';
import { IGetawaysLocations, GetawaysDefaultLocation, GetawaysDefaultLocationCountry } from '@share/common-types';

import './style.scss';

const STATE = 'STATE';

interface IProps {
  value: string;

  options: IGetawaysLocations[];

  disabled?: boolean;
  isCountryBased?: boolean;
  disableSort?:boolean;
  isFirstAll?:boolean;

  onChange: (value: string, isState?: boolean) => void;

  getOptionValue?: (obj: any) => string;
}

export class FilterLocations extends React.Component<IProps> {
  wrapperRef: React.RefObject<HTMLDivElement> = React.createRef();

  getPopupContainer = (): HTMLElement => {
    const element = this.wrapperRef ? this.wrapperRef.current : document.body;
    return element as HTMLElement;
  };

  handleChange = (value: string) => {
    const valueSplit = value.split('|');
    const valueState = get(valueSplit, '[1]');
    const isState = valueState === STATE;

    this.props.onChange(value || '', isState);
  }

  render(): React.ReactNode {
    const { value, disabled = false, disableSort, options, isCountryBased, getOptionValue, isFirstAll = false } = this.props;
    const { Option } = Select;

    const firstOption = isFirstAll && options?.length ? options?.[0] : undefined;
    const optionsRemoved = isFirstAll && options?.length ? [...options].slice(1) : options as any;

    const optionsWithoutCity = optionsRemoved?.filter((item: IGetawaysLocations) => !item.city);
    const optionsRest = optionsRemoved?.filter((item: IGetawaysLocations) => item.city);

    const optionsFiltered: any = optionsRest?.reduce((arr: any, item: any) => {
        const removed = isCountryBased ? arr.filter((i: any) => i.country !== item.country) : arr.filter((i: any)=> i.city !== item.city);
        return [...removed, item];
      }, []) || [];


    if (!disableSort) {
      optionsWithoutCity.sort((a: IGetawaysLocations, b: IGetawaysLocations) => {
        if (isCountryBased) {
          return a.country?.localeCompare(b?.country as string);
        }
        return a.state?.localeCompare(b.state || '');
      });
      optionsFiltered.sort((a: IGetawaysLocations, b: IGetawaysLocations) => {
        if (isCountryBased) {
          return a.country?.localeCompare(b?.country as string);
        }
        return a.city?.localeCompare(b.city || '');
      });
    }

    const optionsWithoutCityFinal = optionsWithoutCity?.length ? [...optionsWithoutCity, { divider: true }] : [];
    let optionsFilteredFinal = [...optionsWithoutCityFinal, ...optionsFiltered];
    if (isFirstAll && firstOption) {
      const firstOptionFinal = optionsWithoutCityFinal?.length ? [firstOption, { divider: true }] : [firstOption];
      optionsFilteredFinal = [...firstOptionFinal, ...optionsFilteredFinal];
    }

    const valueSelected = value || (isCountryBased ? GetawaysDefaultLocationCountry.country : GetawaysDefaultLocation.city);

    return (
      <div className="filter-locations" ref={this.wrapperRef}>
        <Select
          disabled={disabled}
          value={valueSelected}
          onChange={this.handleChange}
          getPopupContainer={this.getPopupContainer}
          showSearch
          filterOption={(input, option: any) => {
            return option?.value?.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }}
        >
          {optionsFilteredFinal.map((obj: any, index: number) => {
            const isDivider = obj?.divider;
            if (isDivider) {
              return (
                <Option key={`divider_${index}`} value={`divider_${index}`} disabled>
                  <div className="filter-locations__divider" style={{ margin: '10px 0', borderTop: '1px solid #e8e8e8' }}></div>
                </Option>
              );
            }
            
            const isState = !obj?.city && !!obj?.state;
            const valueKey = getOptionValue ? getOptionValue(obj) : isCountryBased ? obj?.country : isState ? `${obj?.state}|${STATE}` : obj?.city;
            
            const value = isCountryBased ? obj?.country : isState ? obj?.state : obj?.city;
            const description = value;
            return (
              <Option key={`${valueKey}${obj?.state ? `-${obj?.state}` : ''}`} value={valueKey}>
                <div className="filter-locations__option">
                  {description}
                  {!isCountryBased ? (
                    <div>{`${!isState ? obj?.state || '' : ''}${!isState && obj?.country && obj?.state? ', ' : ''}${obj?.country || ''}`}</div>) : null}
                </div>
              </Option>)})}
        </Select>
      </div>
    );
  }
}
